import { api } from './client';
import type { Tenant, SmtpConfig } from './types';

export function fetchTenants() {
  return api<Tenant[]>('/superadmin/tenants');
}

export function setTenantActivo(id: string, activo: boolean) {
  return api<Tenant>(`/superadmin/tenants/${id}/activo`, {
    method: 'PATCH',
    body: JSON.stringify({ activo }),
  });
}

export function fetchSmtpConfig() {
  return api<SmtpConfig>('/superadmin/smtp');
}

export function saveSmtpConfig(data: Record<string, unknown>) {
  return api('/superadmin/smtp', { method: 'PATCH', body: JSON.stringify(data) });
}

export function testSmtp(to: string) {
  return api('/superadmin/smtp/test', { method: 'POST', body: JSON.stringify({ to }) });
}
